module.exports = __webpack_public_path__ + "static/media/11.074e9135.jpg";